'use strict';
var MailingListController = /** @class */ (function () {
    /*@ngInject*/
    function MailingListController($state, $scope, MailingListService, Auth) {
        'ngInject';
        this.MailingListService = MailingListService;
        this.$scope = $scope;
        this.state = $state;
        this.mailAddress = '';
        this.submitted = false;
        this.infor = false;
        this.emptyEmail = true;
        this.Auth = Auth;
        this.showMailingList = true;
        this.placeholder = 'Enter your email address';
        this.errorMsg = false;
        this.pattern = /^(([^<>()\[\]\.,;:\s@\']+(\.[^<>()\[\]\.,;:\s@\']+)*)|(\'.+\'))@(([^<>()[\]\.,;:\s@\']+\.)+[^<>()[\]\.,;:\s@\']{2,})$/i;
    }
    MailingListController.prototype.$onInit = function () {
        var _this = this;
        this.Auth.isLoggedIn(function (isLoggedIn) {
            if (isLoggedIn) {
                _this.showMailingList = false;
            }
        });
    };
    MailingListController.prototype.sendIterableSubscribeEvent = function (email) {
        var _this = this;
        if (email !== '' && email.match(this.pattern)) {
            this.submitted = true;
            this.MailingListService.iterableMailingListSubscribe(email)
                .then(function (response) {
                if (response.status === 200) {
                    _this.mailAddress = null;
                    _this.infor = true;
                }
                else {
                    _this.errorMsg = true;
                    _this.submitted = false;
                }
            });
        }
        else {
            this.errorMsg = true;
        }
    };
    MailingListController.prototype.submitMail = function (email) {
        var _this = this;
        // Client side null check before submission
        if (email !== '' && email.match(this.pattern)) {
            this.submitted = true;
            this.MailingListService.mailingListsSer(email)
                .then(function (response) {
                // After API success to identify whether mail id submitted or mail id is having error
                if (response.status) {
                    _this.errorMsg = true;
                    _this.submitted = false;
                }
                else {
                    _this.infor = true;
                    _this.mailAddress = null;
                    _this.errorMsg = false;
                }
            })
                .catch(function (err) {
                // Catching API error
                _this.errorMsg = true;
                _this.submitted = false;
            });
        }
        else {
            this.errorMsg = true;
        }
    };
    MailingListController.prototype.emailValidation = function (event) {
        if ((event.target.value && event.target.value.match(this.pattern)) || event.target.value == '') {
            this.errorMsg = false;
        }
        else {
            this.errorMsg = true;
        }
    };
    return MailingListController;
}());
export default MailingListController;
//# sourceMappingURL=mailinglist.component.js.map